// Templates
const templates = window.JST || {}
const buildPath = (path) => path.replace(/\.\//, "utils/templates/")
const removeExtension = (path) => path.replace(/\.jst\.ejs$/, "")

const requireContext = require.context(
  "../../templates/utils/templates/",
  true,
  /\.jst\.ejs$/
)

window._.str = underscoreString

requireContext.keys().forEach(function (modulePath) {
  const templateKey = removeExtension(buildPath(modulePath))
  templates[templateKey] = requireContext(modulePath)
})

window.JST = templates
